"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var use_context_selector_1 = require("use-context-selector");
var styled_1 = require("@eduzz/houston-ui/styled");
var context_1 = tslib_1.__importDefault(require("../context"));
var chat_1 = tslib_1.__importDefault(require("./chat"));
var TopbarUnitySupportChat = function () {
    var user = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.user; });
    (0, react_1.useEffect)(function () {
        if (!(user === null || user === void 0 ? void 0 : user.isClubeBlack))
            return;
        var destroy = (0, chat_1.default)(user);
        return function () { return destroy(); };
    }, [user]);
    return ((0, jsx_runtime_1.jsx)(styled_1.GlobalStyles, { styles: (0, styled_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        #lhc_status_widget_v2 {\n          left: auto !important;\n          bottom: 0 !important;\n          z-index: 102 !important;\n        }\n      "], ["\n        #lhc_status_widget_v2 {\n          left: auto !important;\n          bottom: 0 !important;\n          z-index: 102 !important;\n        }\n      "]))) }));
};
exports.default = TopbarUnitySupportChat;
var templateObject_1;
